import { Star, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS } from "../data/reviews";

const Stars = () => (
  <span className="flex gap-0.5" aria-label="Rated 5 out of 5">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" />
    ))}
  </span>
);

const ReviewCard = ({ r }) => (
  <figure className="w-[300px] shrink-0 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:w-[360px]">
    <Stars />
    <blockquote className="mt-3 text-sm leading-relaxed text-slate-600">“{r.text}”</blockquote>
    <figcaption className="mt-4 flex items-center gap-2.5">
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#D8EFE6] font-display text-xs font-bold text-emerald-800">
        {r.name[0]}
      </span>
      <span>
        <span className="block text-sm font-semibold text-slate-900">{r.name}</span>
        <span className="flex items-center gap-1 text-xs text-slate-400">
          {r.country}
          <BadgeCheck className="h-3.5 w-3.5 text-emerald-600" aria-label="Verified customer" />
        </span>
      </span>
    </figcaption>
  </figure>
);

export const ReviewsSection = () => {
  const rows = [REVIEWS.slice(0, 8), REVIEWS.slice(8)];
  return (
    <section className="border-t border-slate-200 bg-[#F8FAFC] py-24" data-testid="reviews-section">
      <ul className="sr-only">
        {REVIEWS.map((r) => (
          <li key={`${r.name}-${r.country}`}>Rated 5 out of 5 by {r.name}, {r.country}: {r.text}</li>
        ))}
      </ul>

      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-mono text-xs font-semibold tracking-[0.22em] text-emerald-700">CUSTOMER REVIEWS</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              What our customers say
            </h2>
          </div>
          <span className="flex items-center gap-2.5 rounded-full border border-slate-200 bg-white px-4 py-2.5">
            <Stars />
            <span className="font-mono text-sm font-bold text-slate-900">5/5 · 15 reviews</span>
          </span>
        </Reveal>
      </div>

      <div className="mt-12 space-y-5">
        {rows.map((row, ri) => (
          <div key={ri} className="marquee overflow-hidden" data-testid={`reviews-row-${ri + 1}`} aria-hidden="true">
            <div className={`marquee-track flex w-max ${ri === 1 ? "marquee-reverse marquee-slower" : "marquee-slow"}`}>
              {[0, 1].map((copy) => (
                <div key={copy} className="flex gap-5 pr-5">
                  {row.map((r) => (
                    <ReviewCard key={`${copy}-${r.name}`} r={r} />
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
